export default {
    alert(msg, type = 'info') {
        if (type === 'success') {
            this.$noty.success(msg);
        } else if (type === 'warning') {
            this.$noty.warning(msg);
        } else if (type === 'error') {
            this.$noty.error(msg);
        } else {
            this.$noty.info(msg);
        }
    },

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    },

    getNextNumberedNames(name, technical_name, originalId, collection) {
        let lastChar = name[name.length - 1];
        let techName = technical_name;
        let lastCharTech = technical_name[technical_name.length - 1];
        if (!isNaN(lastChar)) {
            name = name.substring(0, name.length - 1);
        }
        if (!isNaN(lastCharTech)) {
            techName = techName.substring(0, techName.length - 1);
        }
        let nrOfDuplicates = 0;
        let firstElementId = originalId;
        for (let i = 0; i < collection.length; i++) {
            let mod = collection[i];
            if (mod.technical_name.indexOf(techName) !== -1) {
                let count = mod.technical_name.replace(new RegExp(techName), '');
                if (!isNaN(parseInt(count)) || count === "") {
                    nrOfDuplicates += 1;
                    if (i < firstElementId) {
                        firstElementId = i;
                    }
                }
            }
        }
        let newNr;
        if (nrOfDuplicates !== 0) {
            newNr = nrOfDuplicates + 1;
        } else {
            newNr = '';
            if (!isNaN(lastChar)) {
                name += lastChar;
            }
            if (!isNaN(lastCharTech)) {
                techName += lastCharTech;
            }
        }
        return {
            name: name + newNr,
            technical_name: techName + newNr,
            insertIndex: firstElementId + nrOfDuplicates
        }
    },

    calcImpressions(line_items, type) {
        let ret = {
            adimpressions: 0,
            desktopAIs: 0,
            tabletAIs: 0,
            mobileAIs: 0,
            totalAIs:0
        };
        if (typeof line_items !== "undefined") {
            if (Array.isArray(line_items)) {
                line_items.forEach((line_item) => {
                    ret.adimpressions += line_item.adimpressions;
                    ret.desktopAIs += line_item.desktop_impressions;
                    ret.tabletAIs += line_item.tablet_impressions;
                });
            } else {
                ret.adimpressions += line_items.adimpressions;
                ret.desktopAIs += line_items.desktop_impressions;
                ret.tabletAIs += line_items.tablet_impressions;
            }

            if (type.toLowerCase() === "online") {
                ret.totalAIs = ret.desktopAIs + ret.tabletAIs;
            } else if (type.toLowerCase() === "desktop") {
                ret.totalAIs = ret.desktopAIs;
            } else if (type.toLowerCase() === "tablet") {
                ret.totalAIs = ret.tabletAIs;
            } else if (type.toLowerCase() === "mobile") {
                ret.totalAIs = ret.adimpressions - (ret.desktopAIs + ret.tabletAIs);
            }
            ret.mobileAIs = ret.adimpressions - (ret.desktopAIs + ret.tabletAIs);
        }

        return ret;
    },

    calcClicks(line_items, type) {
        let ret = {
            clicks: 0,
            desktopClicks: 0,
            tabletClicks: 0,

        };
        if (Array.isArray(line_items)) {
            line_items.forEach((line_item) => {
                ret.clicks += line_item.clicks;
                ret.desktopClicks += line_item.desktop_clicks;
                ret.tabletClicks += line_item.tablet_clicks;
                //
            });
        } else {
            ret.clicks += line_items.clicks;
            ret.desktopClicks += line_items.desktop_clicks;
            ret.tabletClicks += line_items.tablet_clicks;
        }

        if (type.toLowerCase() === "online") {
            ret.totalClicks = ret.desktopClicks + ret.tabletClicks;
        } else if (type.toLowerCase() === "desktop") {
            ret.totalClicks = ret.desktopClicks;
        } else if (type.toLowerCase() === "tablet") {
            ret.totalClicks = ret.tabletClicks;
        } else if (type.toLowerCase() === "mobile") {
            ret.totalClicks = ret.clicks - (ret.desktopClicks + ret.tabletClicks);
        }
        ret.mobileClicks = ret.clicks - (ret.desktopClicks + ret.tabletClicks);
        return ret;
    }
};